// Typed bindings over the generated OpenAPI client (./schema.ts).
//
// schema.ts is produced by `make openapi` (openapi-typescript, version pinned)
// and committed — never hand-edit it. These helpers layer end-to-end request /
// response types onto the shared fetch transport in services/api.ts, so the SPA
// and the Go API cannot drift: a contract change regenerates schema.ts and any
// mismatch surfaces as a TypeScript error here.

import { api } from '../services/api';
import type { components, paths } from './schema';

export type Schemas = components['schemas'];
export type HealthStatus = Schemas['HealthStatus'];
export type Me = Schemas['Me'];
export type ContactRequest = Schemas['ContactRequest'];
export type ContactResult = Schemas['ContactResult'];

// Derived from the generated paths map (not the bare schema) so the binding
// breaks if the operation, status code, or media type ever changes.
type HealthzResponse = paths['/healthz']['get']['responses'][200]['content']['application/json'];

export function getHealthz(signal?: AbortSignal): Promise<HealthzResponse> {
  return api<HealthzResponse>('/healthz', { signal });
}

// postContact submits the public marketing contact form. The request/response
// types are pinned to the generated paths map, so a contract change surfaces
// here as a type error.
type ContactBody = paths['/api/contact']['post']['requestBody']['content']['application/json'];
type ContactResp = paths['/api/contact']['post']['responses'][201]['content']['application/json'];

export function postContact(body: ContactBody, signal?: AbortSignal): Promise<ContactResp> {
  return api<ContactResp>('/api/contact', { method: 'POST', body, signal });
}

// --- App-level health state, surfaced by the status pill (components/HealthPill). ---

export type HealthState =
  | { kind: 'unknown' }
  | { kind: 'ok'; health: HealthStatus }
  | { kind: 'degraded'; health: HealthStatus }
  | { kind: 'error' };

export const HEALTH_EVENT = 'app:health';
const FRESH_MS = 30_000;

let last: HealthState = { kind: 'unknown' };
let lastAt = 0;
let inflight: Promise<HealthState> | null = null;

export function getLastHealth(): HealthState {
  return last;
}

function publish(next: HealthState): HealthState {
  last = next;
  document.documentElement.dataset.health = next.kind;
  window.dispatchEvent(new CustomEvent<HealthState>(HEALTH_EVENT, { detail: next }));
  return next;
}

// Pings /healthz and broadcasts the result. Coalesces concurrent callers (one
// in-flight request) and serves a cached result within FRESH_MS so per-route
// remounts of the pill don't spam the endpoint. Pass force to bypass the cache.
export function checkHealth(force = false): Promise<HealthState> {
  if (inflight) return inflight;
  if (!force && last.kind !== 'unknown' && Date.now() - lastAt < FRESH_MS) {
    return Promise.resolve(last);
  }
  inflight = getHealthz()
    .then((health) =>
      publish(health.status === 'ok' ? { kind: 'ok', health } : { kind: 'degraded', health }),
    )
    .catch(() => publish({ kind: 'error' }))
    .finally(() => {
      lastAt = Date.now();
      inflight = null;
    });
  return inflight;
}
